<template>
  <section class="form">
    <div class="form-desc">
      <div v-if="$slots.title" class="form-title">
        <slot name="title" />
      </div>
      <div v-if="$slots.description" class="form-description">
        <slot name="description" />
      </div>
    </div>
    <!-- <form action="" class="form-container" ref="form">
      <div class="form-row" v-if="name">
        <div class="form-label">
          <label :for="'personal-name-' + id" class="required">Név</label>
        </div>
        <div class="form-control">
          <input
            type="text"
            v-model="personal.name"
            @change="changeValue"
            name="name"
            :id="'personal-name-' + id"
            required="required"
            placeholder="A teljes neved"
          />
        </div>
        <div class="form-error"></div>
      </div>
      <div class="form-row" v-if="email">
        <div class="form-label">
          <label :for="'personal-email-' + id" class="required">E-mail</label>
        </div>
        <div class="form-control">
          <input
            type="email"
            v-model="personal.email"
            @change="changeValue"
            name="email"
            :id="'personal-email-' + id"
            required="required"
            placeholder="Az e-mail címed"
          />
        </div>
        <div class="form-error"></div>
      </div>
      <div class="form-row" v-if="phone">
        <div class="form-label">
          <label :for="'personal-phone-' + id">Telefonszám</label>
        </div>
        <div class="form-control">
          <input
            type="tel"
            v-model="personal.phone"
            @change="changeValue"
            name="phone"
            pattern="^[0-9+-/]*$"
            :id="'personal-phone-' + id"
            placeholder="+36 30 666 66 66"
          />
        </div>
        <div class="form-error"></div>
      </div>
      <div class="form-row">
        <div class="form-label">
          <label>&nbsp;</label>
        </div>
        <div class="form-control">
          <Button
            :disabled="checkEmpty && isEmpty"
            :arrow="buttonArrow || 'right'"
            :class="buttonClass || 'blue fullwidth'"
            >Tovább a kérdőívhez</Button
          >
        </div>
      </div>
    </form> -->
    <Button
      v-if="id === 'footer'"
      to="/irodak"
      :disabled="checkEmpty && isEmpty"
      :arrow="buttonArrow || 'right'"
      :class="buttonClass || 'blue fullwidth'"
      >Térképes kereső</Button
    >
    <div v-if="$slots.content" class="form-content">
      <slot name="content" />
    </div>
  </section>
</template>

<script>
import Button from "@/components/inputs/Button.vue";
import { Validate } from "@/validate.js";

export default {
  name: "ContactForm",
  components: {
    Button
  },
  props: [
    "value",
    "buttonArrow",
    "buttonClass",
    "checkEmpty",
    "id",
    "phone",
    "path",
    "name",
    "email"
  ],
  data() {
    return {
      personal: this.$store.getters.getPersonal || {
        name: "",
        email: "",
        phone: ""
      }
    };
  },
  mounted() {
    const messages = this.$store.getters.getMessages;
    // Validate(this.$refs.form, {
    //   submit: (e) => {
    //     // console.log(e);
    //     e.preventDefault();
    //     this.$router.push(this.path);
    //   },
    //   messages: messages,
    // });
  },
  computed: {
    isEmpty() {
      return (
        this.personal.name == "" ||
        this.personal.email == "" /* ||
        this.personal.phone == "" */
      );
    }
  },
  methods: {
    changeValue() {
      // console.log("e: ", e);
      // this.validate(e.target);
      this.$store.commit("setPersonal", this.personal);
    }
  }
};
</script>

<style lang="scss">
.form {
  display: flex;
  flex-direction: column;
  padding: 24px 24px 12px;

  &.hero-form {
    background: rgb(221, 222, 226);
    // background: rgba(245, 245, 244, 0.44);
    // backdrop-filter: blur(20px);
    border-radius: 12px;
    margin-bottom: 70px;
    padding-bottom: 0;
    form,
    .input-holder {
      display: flex;
      flex-direction: column;
      // align-items: flex-end;
      justify-content: space-between;
      flex-wrap: nowrap;
      .form-row {
        //margin-bottom: 24px;
      }
      .form-control {
        width: 100%;
        //min-width: 219px;
        .button {
          width: 100%;
        }
      }
      .form-label {
        strong {
          font-weight: 400;
        }
      }
    }
    .button {
      // margin-bottom: 16px;
      white-space: nowrap;
    }
  }
  &.footer {
    margin: 0 auto;
    width: 100%;
    max-width: 343px;
    form,
    .input-holder {
      flex-direction: column;
      .form-control {
        .button {
          width: 100%;
        }
      }
    }
    .form-label label {
      color: $white;
    }
  }

  .h3 {
    padding-bottom: 16px;
    border-bottom: 1px solid $lightgray;
  }

  form,
  .input-holder {
    display: flex;
    padding-top: 16px;
    label {
      display: flex;
      flex-direction: column;
    }
  }

  @media screen and (min-width: $breakpoint) {
    &.hero-form {
      margin-bottom: 48px;
      form,
      .input-holder {
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        flex-wrap: nowrap;
        .form-control {
          //margin-bottom: 12px;
        }
        .form-row {
          margin-right: 16px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
    &.footer {
      .form-row {
        margin-bottom: 24px;
      }
    }
  }
}
</style>
